class CustomerService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getCustomers() {
    return this.apiService.get('/api/v1/customers/lookup');
  }

  getPage(params) {
    return this.apiService.get('/api/v1/customers', params);
  }

  getStatistics(params) {
    return this.apiService.get('/api/v1/customers/statistics', params);
  }

  getConditionsPage(params) {
    return this.apiService.get('/api/v1/customers/conditions', params);
  }
}

export default CustomerService;
